import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Toggle from '@atlaskit/toggle';
import Tooltip from '@atlaskit/tooltip';
import { ANALYTICS_ACTION_TOGGLED, ANALYTICS_SUBJECT_RADIO, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { updateMigrationInfo } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { MANAGE_PARTNER_APPS_VIEW, TOGGLE_DUAL_LICENSE } from '../../../../analytics/Events';
const DualLicenseToggle = _ref => {
  let {
    appKey,
    mpacBaseUrl,
    appCloudMigrationData
  } = _ref;
  const [dualLicenseOpted, toggleDualLicenseOpted] = useState(appCloudMigrationData.isDualLicenseOptedIn);
  useEffect(() => {
    toggleDualLicenseOpted(appCloudMigrationData.isDualLicenseOptedIn);
  }, []);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onChangeDualLicense = () => {
    const newDualLicenseStatus = !dualLicenseOpted;
    toggleDualLicenseOpted(newDualLicenseStatus);
    setDualLicense(newDualLicenseStatus);
    handleAnalyticsEvent(newDualLicenseStatus);
  };
  const handleAnalyticsEvent = newDualLicenseStatus => fireAnalyticsEvent({
    eventContainer: MANAGE_PARTNER_APPS_VIEW,
    actionSubject: ANALYTICS_SUBJECT_RADIO,
    action: ANALYTICS_ACTION_TOGGLED,
    actionSubjectId: TOGGLE_DUAL_LICENSE,
    attributes: {
      appKey,
      dualLicenseOpted: newDualLicenseStatus
    }
  });
  const setDualLicense = async dualLicenseBoolean => {
    try {
      const updateRequestBody = _objectSpread(_objectSpread({
        addonKey: appKey
      }, appCloudMigrationData), {}, {
        isDualLicenseOptedIn: dualLicenseBoolean
      });
      await updateMigrationInfo(mpacBaseUrl, appKey, updateRequestBody);
    } catch (error) {
      log.error('DualLicenseToggle', 'Failed to update dual license state', {
        error
      });
    }
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: dualLicenseOpted ? 'Disable dual license' : 'Enable dual license'
  }, /*#__PURE__*/React.createElement(Toggle, {
    onChange: onChangeDualLicense,
    defaultChecked: dualLicenseOpted,
    isChecked: dualLicenseOpted,
    label: "Dual License Toggle"
  }));
};
export default DualLicenseToggle;